import { createComponent } from '@mtfe/sweet';
import { common, dom } from '@mtfe/sweet-utils';
import tpl from './dom.html';
import style from './style.less';

const { isFunction, createUniqueId } = common;
const defaultBtnText = '签到有奖';

const activityEntranceIconID = createUniqueId();

const ActivityEntranceIcon = (props = {}) => {
    const { isShow = true, btnText = defaultBtnText, onClick } = props;
    const data = {
        isShow,
        btnText,
        activityEntranceIconID,
    };
    const events = {
        onClickICon: () => {
            if (isFunction(onClick)) {
                onClick();
            }
        },
    };
    return createComponent(tpl, { data, style }, events);
};

ActivityEntranceIcon.display = () => {
    const iconDom = dom.$id(activityEntranceIconID);
    iconDom.style.display = 'none';
};

export default ActivityEntranceIcon;
